import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../../core/service/app.service';
import { Router, NavigationEnd, Event as RouterEvent, RouterOutlet, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FooterComponent } from '../footer/footer';
import { HeaderComponent } from '../header/header';
import { SidebarComponent } from '../sidebar/sidebar';
import { ThemeCustomizerComponent } from '../theme-customizer/theme-customizer';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app-layout.html',
    standalone: true,
    imports: [NgClass, ThemeCustomizerComponent, SidebarComponent, HeaderComponent, RouterOutlet, FooterComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppLayout implements OnInit, OnDestroy {
    store: any;
    showTopButton = false;
    currentModule: string = '';

    constructor(
        public translate: TranslateService,
        public storeData: Store<any>,
        private readonly service: AppService,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute
    ) {
        this.currentModule = this.activatedRoute.snapshot?.url[0]?.path || '';
    }
    headerClass = '';
    contentPaddingClass: string = 'p-6';
    ngOnInit() {
        this.initStore();
        this.initAnimation();
        this.toggleLoader();
        // Manage content padding based on current route
        const computePadding = (url: string): string => {
            // Add your rules here
            if (url.startsWith('/vendor-master/vendor-detail')) return 'p-0';
            if (url.startsWith('/vendor-kyc-master/vendor-verification-detail')) return 'p-0';
            if (url.startsWith('/team-master/user-detail')) return 'p-0';

            return 'p-5';
        };

        // initialize once on load
        this.contentPaddingClass = computePadding(this.router.url || '');

        // update on navigation
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const url = event.urlAfterRedirects || event.url;
                this.contentPaddingClass = computePadding(url);
            }
        });
        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                this.showTopButton = true;
            } else {
                this.showTopButton = false;
            }
        });
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', () => {});
    }

    initAnimation() {
        this.service.changeAnimation();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.service.changeAnimation();
            }
        });

        const ele: any = document.querySelector('.animation');
        ele.addEventListener('animationend', () => {
            this.service.changeAnimation('remove');
        });
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        setTimeout(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        }, 500);
    }

    initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
